import {
  exists,
  GetClosedDaysRequest,
  GetClosedDaysRequestToJSON,
  HTTPQuery,
  UpdateClosedDaysRequest,
  UpdateClosedDaysRequestToJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'
import * as runtime from '../runtime'

export class ClosedDayApi extends runtime.BaseAPI {
  /**
   * 休館日を取得する
   * 休館日取得
   */
  async getClosedDays(request: GetClosedDaysRequest): Promise<string[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetClosedDaysRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/closed-days', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      exists(jsonValue, 'days') ? jsonValue.days.map(dateToPlainFormat) : []
    ).value()
  }

  /**
   * 休館日を更新する
   * 休館日更新
   */
  async updateClosedDays(
    request: UpdateClosedDaysRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateClosedDaysRequestToJSON(
      request
    )
    const response = await this.requestPut('/closed-days', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
